export const VoiceMap: { [type: string]: string[] } = {
  Male: [
    "Microsoft Guy Online (Natural) - English (United States)",
    "Microsoft Mark - English (United States)",
    "Microsoft James - English (Australia)",
    "Google UK English Male",
    "Microsoft David - English (United States)",
    "urn:moz-tts:sapi:Microsoft James - English (Australia)?en-AU",
    "com.apple.eloquence.en-US.Eddy",
    "com.apple.speech.synthesis.voice.Alex",
    "com.apple.speech.synthesis.voice.daniel",
  ],
  Female: [
    "Microsoft Natasha Online (Natural) - English (Australia)",
    "Microsoft Aria Online (Natural) - English (United States)",
    "Google US English",
    "Google UK English Female",
    "Microsoft Catherine - English (Australia)",
    "Microsoft Zira - English (United States)",
    "urn:moz-tts:sapi:Microsoft Catherine - English (Australia)?en-AU",
    "urn:moz-tts:sapi:Microsoft Zira Desktop - English (United States)?en-US",
    "com.apple.voice.compact.en-US.Samantha",
    "com.apple.speech.synthesis.voice.Victoria",
    "com.apple.speech.synthesis.voice.fiona",
  ],
};

export const getBestVoice = (type: string): SpeechSynthesisVoice | undefined => {
  const voiceOptions = VoiceMap[type];
  const availableVoices = speechSynthesis.getVoices().filter((v) => v.lang.includes("en"));

  console.log(availableVoices);

  for (let voice of voiceOptions) {
    const matchingVoice = availableVoices.find((v) => v.voiceURI === voice);
    if (matchingVoice) {
      console.log("Using Voice: " + matchingVoice.name);
      return matchingVoice;
    }
  }

  return undefined;
};
